import { useI18n } from "../i18n";
import { useState } from "react";
import { Send } from "lucide-react";

export const QuestionBar = ({ active, onAsk }) => {
  const { t } = useI18n();
  const [q, setQ] = useState("");
  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    onAsk(q.trim());
    setQ("");
  };
  return (
    <form onSubmit={submit} className="panel flex items-center gap-3 p-3">
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        disabled={!active}
        placeholder={active ? t("ask") : t("askOff")}
        className="flex-1 bg-transparent outline-none font-mono text-sm px-2 text-primary placeholder:text-subtle disabled:opacity-50"
        data-testid="ghost-question-input"
      />
      <button type="submit" disabled={!active} className="icon-btn" data-testid="ghost-ask-btn">
        <Send size={16} />
      </button>
    </form>
  );
};
